import { render } from "./separatedBtnComponent.vue?vue&type=template&id=383a762c&scoped=true&ts=true"
import script from "./separatedBtnComponent.vue?vue&type=script&lang=ts"
export * from "./separatedBtnComponent.vue?vue&type=script&lang=ts"

import "./separatedBtnComponent.vue?vue&type=style&index=0&id=383a762c&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383a762c"]])

export default __exports__